export default __webpack_public_path__ + "static/media/Elixir of Guile.63f9fbb1.jpg";